import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const DataTypeDate = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 26c5.523 0 10-4.477 10-10S21.523 6 16 6 6 10.477 6 16s4.477 10 10 10Zm0-2.105a7.895 7.895 0 1 0 0-15.79 7.895 7.895 0 0 0 0 15.79Z"
		/>
		<path d="M15 11a1 1 0 0 0-1 1v5l.003.078a1 1 0 0 0 .436.873l3.974 2.71a1 1 0 1 0 1.126-1.652L16 16.595V12a1 1 0 0 0-1-1Z" />
	</svg>
);

export default DataTypeDate;
